import {
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import React, { useState } from "react";
import { FaLink } from "react-icons/fa";
import {
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    RedditIcon,
    RedditShareButton,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    XIcon,
} from "react-share";
import "./Share.scss";

const propTypes = {};

const defaultProps = {};

const Share = ({ shareUrl }) => {
  const [copyLinkTitle, setCopyLinkTitle] = useState("Copy link");
  return (
    <div className="share-container">
      <DialogTitle>Share link to fundraiser</DialogTitle>
      <DialogContent>
        <div className="share-icons">
          <Tooltip title={copyLinkTitle} placement="top">
            <IconButton
              style={{ fontSize: "0.8rem", background: "#f1f1f1" }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setCopyLinkTitle("Link copied");
                navigator.clipboard.writeText(shareUrl);
                setTimeout(() => setCopyLinkTitle("Copy link"), 2000);
              }}
            >
              <FaLink />
            </IconButton>
          </Tooltip>
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <FacebookMessengerShareButton url={shareUrl}>
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
          <WhatsappShareButton url={shareUrl}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
          <TwitterShareButton>
            <XIcon size={32} round />
          </TwitterShareButton>
          <LinkedinShareButton url={shareUrl}>
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
          <RedditShareButton url={shareUrl}>
            <RedditIcon size={32} round />
          </RedditShareButton>
        </div>
      </DialogContent>
    </div>
  );
};

Share.propTypes = propTypes;
Share.defaultProps = defaultProps;

export default Share;
